<template>
  <div>
    <div class="card-layout d-flex flex-column">
      <div class="flex-shrink-0">
        <div style="display: flex; flex-direction: column; gap: 20px">
          <EmailInput
            id="email"
            :field="$v.form.email"
            :checkDomain="firstTry"
            :state="validateState($v.form, 'email')"
            :server-errors="serverErrors['email']"
            @update="$v.form.email.$model = $event"
            @keyupEnter="register"
            field-name="email"
            label="Email address"
            place-holder="name@work-email.com"
          />
          <div v-if="!firstTry" style="display: flex; gap: 16px">
            <StringInput
              id="firstName"
              :field="$v.form.firstName"
              :state="validateState($v.form, 'firstName')"
              :server-errors="serverErrors['firstName']"
              @update="$v.form.firstName.$model = $event"
              @keyupEnter="register"
              field-name="first name"
              label="First name"
              style="flex: 1"
            />
            <StringInput
              id="lastName"
              :field="$v.form.lastName"
              :state="validateState($v.form, 'lastName')"
              :server-errors="serverErrors['lastName']"
              @update="$v.form.lastName.$model = $event"
              @keyupEnter="register"
              field-name="last name"
              label="Last name"
              style="flex: 1"
            />
          </div>

          <PasswordInput
            v-if="!firstTry"
            id="password"
            :field="$v.form.password"
            :state="validateState($v.form, 'password')"
            :server-errors="serverErrors['password']"
            @update="$v.form.password.$model = $event"
            @keyupEnter="register"
            field-name="password"
            label="Password"
            place-holder="******"
          />

          <SubmitButton
            :text="
              firstTry
                ? 'Sign up with your work email'
                : 'Finish creating your account'
            "
            @click.native="register"
            :loading="loading"
            id="submitButton"
          />

          <TextWithLines text="or continue with"></TextWithLines>

          <div style="display: flex; gap: 8px">
            <GoogleButton
              @click.native="googleLogin(form.email)"
            ></GoogleButton>
            <MicrosoftButton
              @click.native="microsoftLogin(form.email)"
            ></MicrosoftButton>
          </div>
          <div style="display: flex; flex-direction: column; gap: 32px">
            <div class="footer-copy text-center">
              By continuing, you agree to our
              <a id="termOfUse" href="https://www.intheloop.io/terms-of-use/">
                Terms of use
              </a>
            </div>
            <HorizontalDivider></HorizontalDivider>
            <div class="footer-copy text-center sign-in">
              Already have an account?
              <a
                style="font-weight: 600"
                id="signIn"
                href="#"
                @click="redirectToWeb()"
                >Sign in</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SubmitButton from "../buttons/SubmitButton";
import register from "@/mixins/loopLogin/register";
import PasswordInput from "../inputs/PasswordInput";
import EmailInput from "../inputs/EmailInput";
import oauthLogin from "../../mixins/oauth/oauthLogin";
import StringInput from "../inputs/StringInput";
import GoogleButton from "../buttons/GoogleButton.vue";
import MicrosoftButton from "../buttons/MicrosoftButton.vue";
import TextWithLines from "../ui/TextWithLines.vue";
import HorizontalDivider from "../ui/HorizontalDivider.vue";
import redirect from "../../mixins/helpers/redirect";

export default {
  name: "RegistrationCard",
  components: {
    HorizontalDivider,
    TextWithLines,
    MicrosoftButton,
    GoogleButton,
    StringInput,
    EmailInput,
    PasswordInput,
    SubmitButton,
  },
  mixins: [register, oauthLogin, redirect],
  props: {
    isInvite: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
  },
  created() {
    const authStrategy = this.$route.query.oauth;

    if (!authStrategy) {
      return;
    }

    authStrategy === "microsoft"
      ? this.microsoftLogin(this.$route.query.login_hint)
      : this.googleLogin(this.$route.query.login_hint);
  },
};
</script>

<style scoped>
.footer-copy {
  color: var(--theme-color-medium);
}

.sign-in {
  font-size: 16px;
}
</style>
